import styled from 'styled-components';
import { color } from '../styles';
import { NavLink } from 'react-router-dom';

export const ContentWrapper = styled.div`
    padding: 4px 8px 16px 8px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1px;
    border-radius: 5px;
    background-color: ${color.emphasis.NEUTRAL_N0};
    flex: 1;
    overflow: visible;
    border: none;
    box-shadow: none;
    min-height: 300px;
    /* Let page handle scrolling; avoid container scrollbars */
`;

export const ExpandableContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1px;
    overflow: visible;
    flex: 1;
    min-height: 0;
    scroll-behavior: smooth;
    /* Allow full growth; page/container manages height */
`;

export const StyledNavLink = styled(NavLink)`
    cursor: pointer;
    color: ${color.primary.BLUE_B100};
    text-decoration: none;
    position: relative;
    font-weight: 500;
    transition:
        color 0.3s ease-in-out,
        letter-spacing 0.3s ease-in-out;

    &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -3px;
        width: 0;
        height: 3px;
        background: linear-gradient(
            90deg,
            ${color.primary.BLUE_B100},
            ${color.primary.BLUE_B200}
        );
        transition:
            width 0.4s ease-in-out,
            left 0.4s ease-in-out;
        border-radius: 2px;
    }

    &:hover {
        color: ${color.primary.BLUE_B200};
        letter-spacing: 0.5px;
    }

    &:hover::after {
        width: 100%;
        left: 0;
    }

    &.active {
        font-weight: bold;
        color: ${color.primary.BLUE_B300};
    }
`;

export const StyledNavLinkNewTab = styled.a`
    cursor: pointer;
    color: ${color.primary.BLUE_B100};
    text-decoration: none;
    position: relative;
    font-weight: 500;
    transition:
        color 0.3s ease-in-out,
        letter-spacing 0.3s ease-in-out;

    &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -3px;
        width: 0;
        height: 3px;
        background: linear-gradient(
            90deg,
            ${color.primary.BLUE_B100},
            ${color.primary.BLUE_B200}
        );
        transition:
            width 0.4s ease-in-out,
            left 0.4s ease-in-out;
        border-radius: 2px;
    }

    &:hover {
        color: ${color.primary.BLUE_B200};
        letter-spacing: 0.5px;
    }

    &:hover::after {
        width: 100%;
        left: 0;
    }

    &.active {
        font-weight: bold;
        color: ${color.primary.BLUE_B300};
    }
`;
